module.exports = __webpack_public_path__ + "img/37_168.9f269af3.png";